var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden",
        },
      ],
      staticClass: "input grid__cell",
      class: _vm.inputClasses,
    },
    [
      _c("div", { staticClass: "input--text" }, [
        _c("p", { staticClass: "text-small-bold black mg mg--b-2" }, [
          _vm._v(_vm._s(_vm.$t(_vm.literal))),
        ]),
        _c("div", { staticClass: "input__wrapper" }, [
          _c("input", {
            attrs: {
              name: _vm.name,
              type: "text",
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              inputmode: "numeric",
            },
            domProps: { value: _vm.value },
            on: {
              change: function ($event) {
                return _vm.updateValue("change", $event)
              },
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }